import React from 'react';
import SpecSelectionListNew from './SpecSelectionListNew';

export default (props) => {
    return (
        <React.Fragment>
            {props.specList.map((spec, idx) => (
                <SpecSelectionListNew
                    spec={spec}
                    key={idx}
                    specIdx={idx}
                    handleChange={props.handleChange}
                />
            ))}
        </React.Fragment>
    );
};
